<template>
    <div>
        <div v-if="!nolabel" class="position-static">
            <b-form-group id="fieldset-timepicker" boundary="viewport" v-bind="$attrs" class="position-static">
                <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
                <div v-if="isAllowEdit && !isUpdatable">
                    <b-input-group class="position-static">
                        <b-input-group-prepend class="position-static">
                            <b-form-timepicker
                                boundary="viewport"
                                v-model="inputModelTime"
                                button-only
                                :hour12="false"
                                locale="en"
                                size="sm"
                                class="bg-transparent boundary-datepicker position-static"
                                aria-controls="input-timepicker"
                                @hidden="setTime"
                            ></b-form-timepicker>
                        </b-input-group-prepend>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelStr"
                            type="text"
                            placeholder="No datetime selected"
                            autocomplete="off"
                            size="sm"
                            v-maska data-maska="##:##"
                            @input="setTimeStr"
                        ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                        {{ errorMessage }}
                    </b-form-invalid-feedback>
                </div>
                <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                    <span>{{ inputModel != "" && inputModel != null ? inputModel : "-" | moment('HH:mm') }}</span>
                    <span class="float-right"><a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
                </div>
                <div v-else>
                    {{ inputModel | moment('HH:mm') }}
                </div>
            </b-form-group>
        </div>
        <div v-else class="position-static">
            <div v-if="isAllowEdit && !isUpdatable" class="position-static">
                <b-input-group class="position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <b-form-timepicker
                            v-model="inputModelTime"
                            button-only
                            :hour12="false"
                            locale="en"
                            size="sm"
                            class="bg-transparent position-static" style="position:static"
                            aria-controls="input-timepicker"
                            @input="setTime"
                        ></b-form-timepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputModelStr"
                        type="text"
                        placeholder="No datetime selected"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##:##"
                        @input="setTimeStr"
                    ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>{{ inputModel != "" && inputModel != null ? inputModel : "-" | moment('HH:mm') }}</span>
                <span class="float-right"><a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                {{ inputModel }}
            </div>
        </div>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-input-group class="mb-3 position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <b-form-timepicker
                            boundary="viewport"
                            v-model="inputPopoverModelTime"
                            button-only
                            :hour12="false"
                            locale="en"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            aria-controls="input-timepicker"
                            @input="setPopoverTime"
                        ></b-form-timepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputPopoverModelStr"
                        type="text"
                        placeholder="No datetime selected"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##:##"
                        @input="setPopoverTimeStr"
                    ></b-form-input>
                </b-input-group>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="setPopoverDateTime" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<style lang="scss" scoped>
    ::v-deep.btn.btn-secondary, ::v-deep.btn.btn-secondary:active, ::v-deep.btn.btn-secondary:hover {
        background-color: transparent !important;
    }
    ::v-deep.form-control:disabled, .form-control[readonly] {
        background-color: transparent !important;
    }
    ::v-deep::placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep:-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep::-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }
</style>
<script>
import moment from 'moment';
import { vMaska } from 'maska';

export default {
    props: ["id", "model", "errorMessage", "state", "suffix", "prefix", "isEditable", "isUpdatable", "change", "nolabel", "label", "isRequired"],
    directives: { maska: vMaska },
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            inputModelDate: '',
            inputModelTime: '',
            inputModelStr: '',
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            value:'',
            groupId : "fieldset-timepicker-" + this.id,
            inputPopoverModelDate: '',
            inputPopoverModelTime: '',
            inputPopoverModelStr: '',
            popoverInputModel:this.model,
            popoverShow: false,
        }
    }, 
    methods: {
        setTime() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelDate != '') {
                inputModelDate = this.inputModelDate;
            }
            let inputModelTime = '00:00';
            if (this.inputModelTime != '') {
                inputModelTime = this.inputModelTime;
            }
            this.inputModel = inputModelDate + ' ' + inputModelTime;
            let date = new Date(this.inputModel);
            if (date) {
                this.inputModelStr = moment(date).format('HH:mm');
            }
            this.$emit('update:model', this.inputModel);
            this.$emit('change')
        },
        setTimeStr() {
            if (this.inputModelStr != null && this.inputModelStr != '') {
                if (this.inputModelStr.length >= 5) {
                    var dateParts = this.inputModelStr.split(":");
                    let date = new Date(2000,1,1,dateParts[0],dateParts[1]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputModel = moment(date).format('HH:mm');
                        console.log(this.inputModel);
                        this.$emit('update:model', this.inputModel);
                        this.$emit('change');
                    } else {
                        this.inputModelStr = date;
                    }
                }
            }
        },
        setLabel(newValue) {
            if (newValue == null) return;
            let date = new Date(newValue);
            if (date != 'Invalid Date') {
                this.inputModelStr = moment(date).format('HH:mm');
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
                this.inputModelTime = moment(date).format('HH:mm');
            }
            this.inputModel = newValue
        },
        setPopoverTime() {
            let inputModelDate = '1970-01-01';
            if (this.inputPopoverModelDate != '') {
                inputModelDate = this.inputPopoverModelDate;
            }
            let inputModelTime = '00:00';
            if (this.inputPopoverModelTime != '') {
                inputModelTime = this.inputPopoverModelTime;
            }
            this.inputPopoverModel = inputModelDate + ' ' + inputModelTime;
            let date = new Date(this.inputPopoverModel);
            if (date) {
                this.inputPopoverModelStr = moment(date).format('HH:mm');
            }
        },
        setPopoverTimeStr() {
            if (this.inputPopoverModelStr != null && this.inputPopoverModelStr != '') {
                if (this.inputPopoverModelStr.length >= 5) {
                    var dateParts = this.inputPopoverModelStr.split(":");
                    let date = new Date(2000,1,1,dateParts[0],dateParts[1]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputPopoverModel = moment(date).format('HH:mm');
                    } else {
                        this.inputPopoverModelStr = date;
                    }
                }
            }
        },
        setPopoverDateTime() {
            this.inputModel = this.inputPopoverModel;
            this.$emit('update:model', this.inputModel);
            this.$emit('change');
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.inputPopoverModelStr = moment(this.inputModel).format('HH:mm');
            this.popoverInputModel = this.inputModel;
            this.inputPopoverModelTime = moment(this.inputModel).format('HH:mm');
            this.popoverShow = true;
        }
    },
    mounted() {
        this.setLabel(this.model);
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        model(newValue) {
            console.log(newValue);
            let date = new Date(newValue);
            if (date != 'Invalid Date') {
                this.inputModelStr = moment(date).format('HH:mm');
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
                this.inputModelTime = moment(date).format('HH:mm');
            }
            this.inputModel = newValue
        },
    }
}
</script>
<style scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
</style>